import { DictionaryLabels } from "@/containers/dictionaries/types";

export const createDictionaryLabels = (
  ns: string,
  labels: Partial<DictionaryLabels> = {},
): DictionaryLabels => ({
  dict: `${ns}.title.multiple`,
  new: `${ns}.new`,
  loading: `${ns}.loading`,
  title: `${ns}.title.single`,
  success: {
    update: `${ns}.success.update`,
    create: `${ns}.success.create`,
  },
  errors: {
    update: `${ns}.errors.update`,
    create: `${ns}.errors.create`,
  },
  ...labels,
});
